import Mutations from '../../odata/mutations';

export default { ...new Mutations('keyword'), ...new Mutations('keywords') };
